import {Pipe, PipeTransform} from '@angular/core';

import {ApplicationsService} from '../../views/admin/provider/applications/applications.service';
import {OrgItem} from '../../views/admin/application-settings/models/orgItem.model';

@Pipe({
    name: 'ngcGetAvailableOrganizations'
})
export class GetAvailableOrganizationsPipe implements PipeTransform {

    constructor(private applicationsService: ApplicationsService) { }

    transform(organizations: OrgItem[], filtredValue: string = '', notAllowedOrganizationsObj: {} = {}, objKeyName: 'name' | 'identifier' = 'name'): OrgItem[] {
        filtredValue = filtredValue ? filtredValue.toLowerCase().trim() : '';
        return this.applicationsService.getAvailableOrganizations(organizations, filtredValue, notAllowedOrganizationsObj, objKeyName);
    }
}
